import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	editButtonLabel: {
		id: 'software.main.board-container.board.card-container.card.story-point-field.edit-button-label',
		defaultMessage: 'Story point estimate: {storyPoints}',
		description: 'Screen reader output for story point estimate field',
	},
});
